import { connect } from 'react-redux';
import { IStoreState } from 'store';
import AdditionalMandate from './additional-mandate-view';

const mapStateToProps = ({ dealEdit }: IStoreState) => ({
  selectedNonStandardRisk: dealEdit.nonstandardRisks,
});

export default connect(mapStateToProps)(AdditionalMandate);
